import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircle, Phone, PhoneCall } from 'lucide-react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../../config/app';
import { trackWebsiteOfferCta } from '../../utils/analytics';
import { OFFER_FORM_PATH } from './ctaStyles';
import { WHATSAPP_OFFER_URL } from './offerData';

const LOCATION = 'mobile_bar';
/** Seuil de scroll (px) au-delà duquel la barre apparaît : on a dépassé le hero. */
const SHOW_AFTER_SCROLL_PX = 560;

const ITEM_CLASS =
  'flex flex-col items-center justify-center gap-1 rounded-lg py-2 text-xs font-semibold text-white transition-colors';

const OfferMobileCtaBar: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_SCROLL_PX);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.nav
          aria-label="Contact rapide"
          className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-[#202225]/95 backdrop-blur px-3 pt-2 pb-[env(safe-area-inset-bottom)]"
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <div className="grid grid-cols-3 gap-2 pb-2">
            <a
              href={`tel:${APP_CONFIG.contact.phoneTel}`}
              className={`${ITEM_CLASS} bg-[#5865F2] hover:bg-[#4752C4]`}
              onClick={() => trackWebsiteOfferCta(LOCATION, 'phone')}
            >
              <Phone className="h-5 w-5" aria-hidden="true" /> Appeler
            </a>
            <a
              href={WHATSAPP_OFFER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`${ITEM_CLASS} bg-green-600 hover:bg-green-700`}
              onClick={() => trackWebsiteOfferCta(LOCATION, 'whatsapp')}
            >
              <MessageCircle className="h-5 w-5" aria-hidden="true" /> WhatsApp
            </a>
            <Link
              to={OFFER_FORM_PATH}
              className={`${ITEM_CLASS} bg-white/10 border border-white/20 hover:bg-white/15`}
              onClick={() => trackWebsiteOfferCta(LOCATION, 'form')}
            >
              <PhoneCall className="h-5 w-5" aria-hidden="true" /> Être rappelé
            </Link>
          </div>
        </motion.nav>
      )}
    </AnimatePresence>
  );
};

export default OfferMobileCtaBar;
